// extracted by mini-css-extract-plugin
export default {"custom-rules-container":"EditRules_custom-rules-container__Czjnp","add-rule-button":"EditRules_add-rule-button__JejKl"};